import React, { useState, useEffect } from "react";
import Datagrid from "@ui/components/DataGrid";
import {
  buttonClassName,
  nexStepButtonStyle,
} from "../../../AddNewTest/constants";
import { useFetch } from "../../../../../hooks/fetch.hook";
import { linkLaboratories } from "../_api";
import SearchBar from "@ui/components/SearchBar";
import { laboratoryHeadings } from "../constants";
import { renderLaboratoriesRow } from "../../Laboratories/helpers";

const HEADINGS = [
  ["trading_name", "Organisation Name"],
  ["phone", "Phone Number"],
  ["email", "Email Address"],
  ["status", "Status"],
];
const headerStyle = {
  background: "#E8F5E1",
  color: "#71BF44",
};

export const LaboratoriesList = ({
  data,
  handleClose,
  testId,
  setNonLinkedLaboratories,
  updateLaboratoriesList,
  setLoading,
}) => {
  const { request } = useFetch();

  const [selected, setSelected] = useState({});
  const [initialData, setInitialData] = useState([]);

  useEffect(() => {
    setInitialData(data);
    // eslint-disable-next-line
  }, []);

  const KEY_MAP = {
    "Organisation Name": data.map((item) => item.trading_name),
    "Phone Number": data.map((item) => item.phone),
    "Email Address": data.map((item) => item.email),
    Status: data.map((item) => item.status),
  };

  const handleSearch = (search, isRemoveKey) => {
    setNonLinkedLaboratories(
      (isRemoveKey ? initialData : data).filter((item) => {
        const _search = Object.entries(search).map((item) => [
          laboratoryHeadings.find((i) => i[1] === item[0])[0],
          item[1],
        ]);
        return (
          _search.length === 0 ||
          _search.every(([k, v]) => {
            if (Array.isArray(item[k])) {
              return item[k].includes(v);
            }
            return item[k] === v;
          })
        );
      })
    );
  };

  const handleSubmit = () => {
    setLoading(true);
    const payload = Object.keys(selected)
      .filter((item) => Boolean(selected[item]))
      .map((item) => ({
        id: item,
      }));
    request(linkLaboratories, payload, testId).then((data) => {
      if (!data) return;
      updateLaboratoriesList();
      handleClose();
    });
  };

  const resetSearch = () => setNonLinkedLaboratories(initialData);

  const selectedCount = Object.values(selected).filter(Boolean).length;

  return (
    <>
      <div className="bg-white rounded p-10">
        <h4 className="mb-6">
          <strong>Select Laboratories</strong>
        </h4>
        <div className="mb-10">
          <SearchBar
            onSearch={handleSearch}
            clearSearch={resetSearch}
            keyMap={KEY_MAP}
            placeholder="Filter Laboratories..."
            elevation={2}
            chipBackgroundColor="#E8F5E1"
            chipColor="#255915"
          />
        </div>
        <div className="border 1px solid #E5E5E5">
          <div
            className="d-flex justify-content-between p-5 align-items-center"
            style={headerStyle}
          >
            <h6>{`${
              selectedCount > 1
                ? `${selectedCount} items`
                : `${selectedCount} item`
            } selected`}</h6>
          </div>
          <Datagrid
            data={data}
            headings={HEADINGS}
            renderRow={renderLaboratoriesRow}
            selected={selected}
            setSelected={setSelected}
            selectable
          />
        </div>
        <div className="row mt-10">
          <div className="col-6 text-center">
            <button className={buttonClassName} onClick={handleClose}>
              Cancel
            </button>
          </div>
          <div className="col-6 text-center">
            <button
              className={nexStepButtonStyle}
              onClick={handleSubmit}
              disabled={!selectedCount}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
